import { useRouter } from 'next/router'
import React, { useCallback, useEffect, useState } from 'react'

import cn from 'classnames'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

import {
  Box,
  Button,
  IconButton,
  List,
  ListItem,
  SwipeableDrawer
} from '@material-ui/core'

import { Flexbox, Logo, NavLink, Text } from '~/components/shared'
import { useHeaderTabsArray } from '~/components/tabs/HeaderTabs/HeaderTabs.config'

import { getRole } from '~/state/modules/user'
import { AppState } from '~/state/store'

import CloseIcon from '~/assets/icons/close.svg'
import MenuIcon from '~/assets/icons/menu.svg'
import { ROLES } from '~/constants/roles'
import ROUTES from '~/constants/routes'

import { useMobileStyles } from './Header.styles'
import { useHeaderListArray } from './HeaderPopover/HeaderList.config'

const scope = 'components.layouts.Header.HeaderMobile'

const HeaderMobile: React.FC<HeaderProps> = ({
  incomingMessages,
  logged,
  logout
}) => {
  const s = useMobileStyles()

  const HeaderTabsArray = useHeaderTabsArray()
  const HeaderListArray = useHeaderListArray()

  const { pathname } = useRouter()

  const role = useSelector(getRole)
  const uiSettings = useSelector((state: AppState) => state.user?.ui_setting)

  const [open, setOpen] = useState<boolean>(false)

  const handleSidebar = useCallback(() => {
    setOpen(!open)
  }, [open])

  useEffect(() => {
    setOpen(false)
  }, [pathname])

  return (
    <>
      <header className={s.root}>
        <Flexbox className={s.container}>
          <Logo
            className={s.logo}
            src={uiSettings?.logo_link}
            width={uiSettings?.logo_width}
          />

          {logged && (
            <IconButton onClick={handleSidebar}>
              <MenuIcon />
            </IconButton>
          )}
        </Flexbox>
      </header>

      <SwipeableDrawer
        anchor="right"
        open={open}
        onOpen={handleSidebar}
        onClose={handleSidebar}
        disableBackdropTransition
        classes={{
          paper: s.paper,
          modal: s.modal
        }}
      >
        <Flexbox className={cn(s.container, s.header)}>
          <Logo
            className={s.logo}
            src={uiSettings?.logo_link}
            width={uiSettings?.logo_width}
          />

          <IconButton onClick={handleSidebar}>
            <CloseIcon />
          </IconButton>
        </Flexbox>

        {logged && (
          <>
            <Box className={s.linksWrapper}>
              <List>
                {HeaderTabsArray.map((tab) => {
                  if (role === ROLES.clinic && tab.value === ROUTES.clinics)
                    return null

                  return (
                    <ListItem key={tab.value} className={s.tabItem}>
                      <NavLink
                        href={tab.value}
                        className={
                          incomingMessages &&
                          tab.value === ROUTES.referrals &&
                          s.notification
                        }
                      >
                        <Text>{tab.label}</Text>
                      </NavLink>
                    </ListItem>
                  )
                })}
              </List>
            </Box>

            <Box className={s.linksWrapper}>
              <List>
                {HeaderListArray.map(({ label, value }) => (
                  <ListItem key={value}>
                    <NavLink href={value}>
                      <Text>{label}</Text>
                    </NavLink>
                  </ListItem>
                ))}
              </List>
            </Box>
          </>
        )}

        <Box className={s.btnsWrapper}>
          {logged && (
            <Button
              variant="outlined"
              onClick={logout}
              className={s.logOut}
              fullWidth
            >
              <FormattedMessage
                id={`${scope}.logoutMobile`}
                defaultMessage="Logout"
              />
            </Button>
          )}
        </Box>
      </SwipeableDrawer>
    </>
  )
}

export default HeaderMobile
